import { render, staticRenderFns } from "./ListadoCategoriaUniversidad.vue?vue&type=template&id=408160f4"
import script from "./ListadoCategoriaUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoCategoriaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoCategoriaUniversidad.vue?vue&type=style&index=0&id=408160f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports